import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import VizyonVeTemsil from "./sections/VizyonVeTemsil";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <VizyonVeTemsil />
      <Footer />
    </div>;
}